export const L10N = {
  ACTION_SEARCH: { id: 'common.action.search' },
  LABEL_PROMOTION: { id: 'common.label.promotion', defaultMessage: '　　　　' },
  // ! TODO: Remove this one
  LABEL_CODE: { id: 'common.label.promo_code', defaultMessage: '　　　　' },
};
